import React, { useState, useEffect } from 'react';
import { Fab } from 'components';
import includeMe from 'utilities/script';
import BottomDrawerModal from './modal';
import Send from 'components/Icons/Send';
import { IFab } from 'components/Fab';
import { IPageConfigProcessed, WidgetUtils } from '../../utilities/widgetUtils';
import { CookieUtils } from '../../utilities/cookie';
import { COOKIE_VALUES, EVENT_NAME } from 'utilities/variables';
import {
  IRedirectWidgetCustomisation,
  WidgetSchema,
  ISO_CODES_VALUES,
} from '@bikdotai/bik-models/dm';

export interface IBottomDrawer extends WidgetSchema {
  id?: string;
  environment: string;
  preview?: boolean;
  isMobile?: boolean;
  storeWidgetConfig: IPageConfigProcessed;
  previewLanguage?: ISO_CODES_VALUES;
}

const BottomDrawer = (props: IBottomDrawer) => {
  const [showModal, setShowModal] = useState(false);
  const [showFab, setShowFab] = useState(false);
  const [showWidget, setShowWidget] = useState(false);
  const { widgetCustomisation } = props as {
    widgetCustomisation: IRedirectWidgetCustomisation;
  };
  const widgetUtils = new WidgetUtils();
  const cookieUtils = new CookieUtils();

  cookieUtils.addItemInLocalStorage('storeId', props.info?.storeId);

  cookieUtils.cookieClickHandler(
    `bik-${props.id}-visitor`,
    COOKIE_VALUES.BIK_VISITOR,
    EVENT_NAME.WIDGET_VISITED,
    1,
    props.environment,
    props.id,
  );

  const fabStyle: IFab = {
    icon: <Send color={widgetCustomisation?.iconColor} />,
    onClick() {
      cookieUtils.cookieClickHandler(
        `bik-${props.id}-clicked`,
        'bikclick',
        'WIDGET_CLICKED',
        1,
        props.environment,
        props.id,
      );
      setShowFab(false);
      setShowModal(true);
    },
    isMobile: props.isMobile,
    preview: props.preview ?? false,
    widgetCustomisation: {
      iconColor: widgetCustomisation?.iconColor,
      fabTransform: widgetCustomisation?.fabTransform,
      fabPositioner: widgetCustomisation?.fabPositioner,
      fabBackgroundColor: widgetCustomisation?.fabBackgroundColor,
      fabLottie: widgetCustomisation?.fabLottie,
      fabAnimationRun: widgetCustomisation?.fabAnimationRun,
      fabImage: widgetCustomisation?.fabImage,
      fabIconLink: widgetCustomisation?.fabIconLink,
      fabWebSize: widgetCustomisation?.fabWebSize,
      fabMobileSize: widgetCustomisation?.fabMobileSize,
    },
  };

  useEffect(() => {
    if (!props.preview) {
      const shouldShow = widgetUtils.showWidget(
        {
          currentUrl: window.location.href.replace(window.location.origin, ''),
          customUrls: props.storeWidgetConfig,
          currentWidgetId: props.id,
        },
        props.info.isAutomationTesting,
      );
      setShowFab(shouldShow);
      setShowWidget(shouldShow);
    } else {
      setShowFab(true);
    }
  }, [window.location.href]);

  return (
    <>
      {showWidget && (
        <div id={`bik-widget-root-${props.id}`}>
          {showFab && <Fab {...fabStyle} id={`bik-bd-${props.id}-cta-fab`} />}
          <BottomDrawerModal
            {...props}
            showModal={showModal}
            onClose={() => {
              setShowFab(true);
              setShowModal(false);
            }}
          />
        </div>
      )}
    </>
  );
};

export default React.memo(BottomDrawer);

if (process.env.NODE_ENV !== 'development') {
  includeMe(BottomDrawer);
}
